import { TranslationLabels } from '@generated/translation-labels';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useCountry } from '@shared/hooks';
import React, { FC, ReactNode, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as SearchCircleIcon } from '@heimstaden/icons-library/img/streamline-regular/interface-essential/search/search-circle.svg';
import { SearchBox } from '@shared/components';
import { useTranslation } from '@shared/translations';
import { useProfile } from '../../../+profile';
import { Icon } from '../icons';
import { api } from './header-search-box.repository';
import { Suggestion } from './header-search-box.type';

export const HeaderSearchBox: FC = () => {
  const country = useCountry();
  const { t, langCode } = useTranslation();
  const { isTenant } = useProfile();
  const sanityLangCode = useMemo<GenericTypes.SanityLanguageKey>(
    () => (langCode === 'en' ? 'en' : 'native'),
    [langCode],
  );
  const callback = useCallback(
    (query: string): Promise<Suggestion[]> =>
      api.getSuggestions$(country, isTenant, sanityLangCode, query),
    [country, isTenant, sanityLangCode],
  );
  const getElementTemplate = (
    className: string,
    { externalWebpageURL, route, titleKey }: Suggestion,
    handleClick: () => void,
  ): ReactNode => (
    <Button
      {...(externalWebpageURL
        ? {
            href: externalWebpageURL,
            rel: 'noopener noreferrer',
            target: '_blank',
          }
        : { component: Link, to: route })}
      className={className}
      onClick={handleClick}
    >
      <Typography>
        {Array.isArray(titleKey)
          ? titleKey.map((key) => t(key)).join(' -> ')
          : t(titleKey)}
      </Typography>
    </Button>
  );
  const iconTemplate = <Icon icon={SearchCircleIcon} height={32} width={32} />;

  return (
    <SearchBox<Suggestion>
      callback={callback}
      getElementTemplate={getElementTemplate}
      placeholderKey={TranslationLabels.headerSearchInput}
      iconTemplate={iconTemplate}
    />
  );
};
